/**
* index.js
* Copyright: Microsoft 2016
*
* Points at typescript source for using with webpack/TSC.
*/

module.exports = require('./dist/SimpleRestClients');
